import * as React from "react";
import {
  Typography,
  Stack,
  Box,
  Tooltip,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import emptyIcon from "../../../assets/images/Icons/search-table.png";
import { formatWeightWithUnits } from "../../../utils";

const PriorityCard = ({ priority, items, handleSelect, globalData, state }) => {
  return (
    <Stack gap="8px">
      {/* Priority Header */}
      <Box height="40px" display="flex" alignItems="end">
        <Typography
          sx={{
            color: "primary.main",
            fontWeight: 500,
            fontSize: "16px",
          }}
        >
          PRIORITY {priority}
        </Typography>
      </Box>

      <List
        disablePadding
        sx={{
          border: 1,
          borderColor: "divider",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        {items.map((item, index) => {
          // Check if this item is the currently selected one
          const isSelected =
            state.selectedBatchPriority === item.priority &&
            state.selectedBatchIndex === index;
          return (
            <React.Fragment key={index}>
              <ListItemButton
                selected={isSelected}
                sx={{
                  "&.Mui-selected, &.Mui-selected:hover": {
                    backgroundColor: "primary.main",
                    color: "#ffff",
                  },
                  backgroundColor: "background.paper",
                }}
                onClick={() => handleSelect({ priority: item.priority, index })}
              >
                <ListItemText
                  primary={item.recipe_name}
                  secondary={
                    <Stack
                      color={isSelected ? "#ffff" : "#8E99AC"}
                      component="span"
                      direction="row"
                      gap={1}
                    >
                      <Typography
                        fontWeight={500}
                        fontSize="12px"
                        color={isSelected ? "" : "text.primary"}
                      >
                        {formatWeightWithUnits(
                          item?.total_weight,
                          item?.total_weight_unit,
                          globalData?.all_Units
                        )}
                      </Typography>
                      <Tooltip title={item.template_name} arrow>
                        <Typography
                          fontWeight={500}
                          fontSize="12px"
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "150px", // Adjust based on your layout
                            display: "inline-block",
                          }}
                        >
                          • {item.template_name}
                        </Typography>
                      </Tooltip>
                    </Stack>
                  }
                  primaryTypographyProps={{
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                />
                <ArrowForwardIosIcon fontSize="16px" />
              </ListItemButton>
              {index !== items.length - 1 && <Divider variant="fullWidth" />}
            </React.Fragment>
          );
        })}
      </List>
    </Stack>
  );
};

export const BatchListCard = (props) => {
  const { data, state, handleSelect, globalData } = props;

  // Group data by priority
  const groupedByPriority = React.useMemo(() => {
    return (
      data?.reduce((acc, item) => {
        acc[item.priority] = acc[item.priority] || [];
        acc[item.priority].push(item);
        return acc;
      }, {}) || {}
    );
  }, [data]);
  // Component to render each priority group

  return (
    <>
      <Box>
        <Stack height="34px" justifyContent="center">
          <Typography fontWeight={600} fontSize="12px">
            Recipe Name
          </Typography>
        </Stack>
        {data?.length ? (
          <Box>
            {Object.keys(groupedByPriority).map((priority) => (
              <PriorityCard
                key={priority}
                priority={priority}
                items={groupedByPriority[priority]}
                globalData={globalData}
                handleSelect={handleSelect}
                state={state}
              />
            ))}
          </Box>
        ) : (
          <Stack
            sx={{
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "#f5f7fa",
            }}
          >
            <img src={emptyIcon} alt="empty" height={56} width={56} />
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#485364",
              }}
            >
              There are no batches yet!
            </Typography>
          </Stack>
        )}
      </Box>
    </>
  );
};
